
<!-- Messages -->
<div class="form-message" *ngIf="errorMessage">
  <div class="form-message-error">
    {{ errorMessage }}
  </div>
</div>
<div class="form-message" *ngIf="successMessage">
  <div class="form-message-success">
    {{ successMessage }}
  </div>
</div>

<!-- Profile Form -->
<div id="profile" class="w-full max-w-lg mx-auto px-4 pt-2 pb-8">
  <div class="form-container">
    <div class="form-header">
      <h2 class="form-title">Profile Update</h2>
      <p class="form-subtitle">Update your profile information below.</p>
    </div>
    <form [formGroup]="profile" (ngSubmit)="onSubmit()" class="form-body">
      <!-- First Name -->
      <div class="form-field">
        <label for="fname" class="form-label">First Name</label>
        <div class="form-field-input-wrapper">
          <input 
            id="fname" 
            type="text" 
            formControlName="fname"
            class="form-input" />
        </div>
      </div>

      <!-- Last Name -->
      <div class="form-field">
        <label for="lname" class="form-label">Last Name</label>
        <div class="form-field-input-wrapper">
          <input 
            id="lname" 
            type="text" 
            formControlName="lname"
            class="form-input" />
        </div>
      </div>

      <!-- Date of Birth -->

      <div class="form-field">
        <label for="dob" class="form-label">Date of Birth</label>
        <div class="form-field-input-wrapper">
          <input id="dob" type="text" formControlName="dob" placeholder="MM/DD/YYYY" class="form-input" />
          <small class="form-hint">Format: MM/DD/YYYY</small>
        </div>
      </div>

      <!-- State Selection -->
      <div class="form-field">
        <label for="licenseinstate" class="form-label">License State</label>
        <div class="form-field-input-wrapper">
          <select 
            id="licenseinstate"
            formControlName="licenseinstate"
            style="display: block !important; visibility: visible !important; opacity: 1 !important;"
            class="form-select">
            <option value="" disabled>Choose your state</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </div>
      </div>

      <!-- Submit Buttons -->
      <div class="flex gap-4 pt-4">
        <button 
          type="button"
          (click)="goToCourses()"
          class="form-button form-button-secondary flex-1">
          Back to Courses
        </button>
        <button 
          type="submit"
          [disabled]="!profile.valid"
          class="form-button form-button-primary flex-1">
          Save Profile
        </button>
      </div>
    </form>
  </div>
</div>